import React from 'react';

/*
 * Circular icon container (SPEC §8). variant: 'default' (bg-card-2) | 'accent' (cyan).
 * `size` is the diameter in px.
 */
export default function IconChip({ children, size = 48, variant = 'default', className = '', ...rest }) {
  return (
    <span
      className={`icon-chip icon-chip--${variant}${className ? ` ${className}` : ''}`}
      style={{ width: size, height: size }}
      {...rest}
    >
      {children}
    </span>
  );
}
